import { render, staticRenderFns } from "./ViewVendor.vue?vue&type=template&id=9cbe6220"
import script from "./ViewVendor.vue?vue&type=script&lang=js"
export * from "./ViewVendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports